<template>
  <div style="height: calc(100vh - 120px);">
    <listToolbar :toolbar="toolbar" @toolTap="toolTap" @addTap="addTap" />
    <listTable
      :list="list"
      :page="page"
      :loading="loading"
      :total="total"
      :pageSize="pageSize"
      :columns="columns"
      @page-change="pageChange" />
    <el-drawer v-model="formDrawerVisible" size="30%" :title="typeForm === 'add'? '添加' : '修改'">
      <div v-if="formDrawerVisible" style="padding-left: 16px; padding-right: 16px;">
        <Form :columns="addColumns" :type="typeForm" @submit="submit" />
      </div>
    </el-drawer>
    <el-drawer v-model="formDrawerVisible2" size="30%" title="详情">
      <div v-if="formDrawerVisible2" style="padding-left: 16px; padding-right: 16px;">
        <formSee :columns="addColumnsDet" />
      </div>
    </el-drawer>
  </div>
</template>

<script>
import {
  goodsTypeList,
  schoolGoodsOutboundDetail,
  schoolGoodsOutboundList,
  stockGoodsOutboundDel,
  stockGoodsOutboundSubmit
} from '@/apis/common'
import ListToolbar from '@/components/system/listToolbar.vue'
import listTable from '@/components/system/listTable.vue'
import formSee from '@/components/system/formSee.vue'
import Form from '@/components/system/form.vue'

export default {
  name: 'inbound',
  components: { Form, formSee, listTable, ListToolbar },
  data() {
    return {
      info: JSON.parse(sessionStorage.getItem('user')) || {},
      page: 1,
      pageSize: 15,
      total: 0,
      loading: false,
      toolbar: [
        {type: 'input', label: '商品名称', model: 'goods_name', value: ''},
        {type: 'select', label: '商品类型', model: 'type_id', value: '', options: []},
        {type: 'date', label: '开始日期', model: 'start_date', value: ''},
        {type: 'date', label: '结束日期', model: 'end_date', value: ''},
        {type: 'button', label: '搜索', icon: 'el-icon-search', def: 'default', key: 'search'},
        {type: 'button', label: '添加', def: 'primary',key: 'add'}
      ],
      formData: {
        goods_name: '',
        type_id: '',
        start_date: '',
        end_date: '',
        goods_id: ''
      },
      list: [],
      columns: [
        {label: '入库记录ID', prop: 'id', width: 100, type: 'text'},
        {label: '商品名称', prop: 'goods_name', width: 200, type: 'text'},
        {label: '商品分类', prop: 'type_name', width: 100, type: 'text'},
        {label: '数量', prop: 'num', width: 100, type: 'text'},
        {label: '实际售价', prop: 'sale_price', width: 100, type: 'text'},
        {label: '合计金额', prop: 'total_price', width: 100, type: 'text'},
        {label: '销售员姓名', prop: 'sale_user_name', width: 100, type: 'text'},
        {label: '收款方式', prop: 'pay_type', width: 80, type: 'tag',  arr: [
            {key: 1,type: 'success', label: '微信'},
            {key: 2,type: 'success', label: '支付宝'},
            {key: 3,type: 'success', label: '现金'},
            {key: 4,type: 'success', label: '转账'},
            {key: 5,type: 'success', label: '其他'},
            {key: 6,type: 'success', label: '余额'},
          ]},
        {label: '出库时间', prop: 'sale_date', width: 150, type: 'text'},
        {label: '添加时间', prop: 'created_at', width: 150, type: 'text'},
        {label: '操作', width: 200, type: 'but', arr: [
            {type: 'default', icon: 'el-icon-document', label: '查看', onClick: (row) => this.seeDetails(row)},
            {type: 'danger', icon: 'el-icon-delete', label: '删除', onClick: (row) => this.del(row)}
          ]}
      ],
      typeForm: 'add',
      formDrawerVisible: false,
      formDrawerVisible2: false,
      addColumns: [
        {label: '商品', prop: 'goods_id', value: '', type: 'goods'},
        {label: '实际售价', prop: 'sale_price', value: '', type: 'input'},
        {label: '销售日期', prop: 'sale_date', value: '', type: 'date'},
        {label: '数量', prop: 'num', value: '', type: 'input'},
        {label: '合计金额', prop: 'total_price', value: '', type: 'input'},
        {label: '收款方式', prop: 'pay_type', value: '', type: 'select', options: [
            {label: '微信', value: 1},
            {label: '支付宝', value: 2},
            {label: '现金', value: 3},
            {label: '转账', value: 4},
            {label: '其他', value: 5},
            {label: '余额', value: 6},
          ]},
        {label: '销售人员', prop: 'sale_user_id', value: '', type: 'input'},
        {label: '销售对象', prop: 'buy_user_type', value: '', type: 'select', options: [
            {label: '在校学生', value: 1},
            {label: '其他', value: 2},
          ]},
        {label: '学生姓名', prop: 'buy_user_id', value: '', type: 'student',  options: []},
        {label: '其他人姓名', prop: 'buy_name', value: '', type: 'input'},
        {label: '其他人电话', prop: 'buy_phone', value: '', type: 'input'},
        {label: '备注信息', prop: 'note', value: '', type: 'textarea'},
      ],
      addFormData: {},
      addColumnsDet: [
        {label: '商品', prop: 'goods', type: 'tag',value: '' ,name: 'goods_name'},
        {label: '出库日期', prop: 'sale_date', type: 'date',value: '' },
        {label: '实际售价', prop: 'sale_price', type: 'input',value: '' },
        {label: '折扣', prop: 'discount', type: 'input',value: '' },
        {label: '出库数量', prop: 'num', type: 'input',value: '' },
        {label: '收款方式', prop: 'pay_type', type: 'select',value: '' , options: [
            {label: '微信', value: 1},
            {label: '支付宝', value: 2},
            {label: '现金', value: 3},
            {label: '转账', value: 4},
            {label: '其他', value: 5},
            {label: '余额', value: 6},
          ]},
        {label: '销售对象', prop: 'buy_user_type', type: 'select',value: '' , options: [
            {label: '在校学生', value: 1},
            {label: '其他', value: 2},
          ]},
        {label: '销售员姓名', prop: 'sale_user_name', type: 'input',value: '' },
        {label: '姓名', prop: 'buy_name', type: 'input',value: '' },
        {label: '电话', prop: 'buy_phone', type: 'input',value: '' },
        {label: '添加时间', prop: 'created_at', type: 'date',value: '' },
        {label: '备注', prop: 'note', type: 'input',value: '' },
      ]
    }
  },
  mounted() {
    this.getSchoolGoodsInboundList()
    this.getGoodsTypeList()
  },
  methods:{
    getSchoolGoodsDetail(row) {
      schoolGoodsOutboundDetail({
        admin_id: this.info.id,
        school_id: this.info.agency_school_id,
        outbound_id: row.id
      }).then(res => {
        this.addColumnsDet.forEach(item => {
          item.value = res.data.data[item.prop]
        })
      })
    },
    // 查看
    seeDetails(row) {
      this.getSchoolGoodsDetail(row)
      this.formDrawerVisible2 = true
    },
    // 删除
    del(row) {
      this.addFormData = row
      this.$confirm('确定要删除吗?', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        stockGoodsOutboundDel({
          admin_id: this.info.id,
          school_id: this.info.agency_school_id,
          outbound_id: row.id
        }).then(res => {
          this.$message.success('删除成功')
          this.getSchoolGoodsInboundList()
        })
      }).catch(() => {})
    },
    submit(e,n) {
      let form = {
        admin_id: this.info.id,
        school_id: this.info.agency_school_id,
        ...e
      }
      stockGoodsOutboundSubmit(form).then(res => {
        this.formDrawerVisible = false
        this.$message.success('操作成功')
        this.getSchoolGoodsInboundList()
      })
    },
    addTap() {
      this.addColumns.forEach(item => {
        item.value = ''
      })
      this.formDrawerVisible = true
      this.typeForm = 'add'
    },
    // 分页
    pageChange(e) {
      this.page = e
      this.getSchoolGoodsInboundList()
    },
    toolTap(data) {
      this.formData = data
      this.page = 1
      this.getSchoolGoodsInboundList()
    },
    getGoodsTypeList() {
      goodsTypeList({
        admin_id: this.info.id,
        school_id: this.info.agency_school_id,
      }).then(res => {
        this.toolbar[1].options = res.data.data.map(x => {
          return {label: x.name, value: x.id}
        })
      })
    },
    getSchoolGoodsInboundList() {
      this.loading = true
      schoolGoodsOutboundList({
        page: this.page,
        pagesize: this.pageSize,
        admin_id: this.info.id,
        school_id: this.info.agency_school_id,
        ...this.formData
      }).then(res => {
        this.total = res.data.data.count
        this.list = res.data.data.list
        this.loading = false
      })
    }
  }
}
</script>

<style scoped>

</style>
